
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_n1fwt_11dqq_149",
  "header-inner": "awsui_header-inner_n1fwt_11dqq_181",
  "header": "awsui_header_n1fwt_11dqq_181",
  "body": "awsui_body_n1fwt_11dqq_190",
  "footer": "awsui_footer_n1fwt_11dqq_198",
  "refresh": "awsui_refresh_n1fwt_11dqq_264",
  "highlighted": "awsui_highlighted_n1fwt_11dqq_267",
  "variant-embedded": "awsui_variant-embedded_n1fwt_11dqq_274",
  "inner-card": "awsui_inner-card_n1fwt_11dqq_274",
  "variant-default": "awsui_variant-default_n1fwt_11dqq_274",
  "no-padding": "awsui_no-padding_n1fwt_11dqq_280",
  "with-actions": "awsui_with-actions_n1fwt_11dqq_305",
  "full-height": "awsui_full-height_n1fwt_11dqq_351",
  "description": "awsui_description_n1fwt_11dqq_355"
};
  